module.exports = new __parcel__URL__("logo.b93ae0f9.png").toString();